module.exports = __webpack_public_path__ + "static/media/image_place_holder.6a9d678d.png";